export default ["app", "user", "event", "guest", "vendor", "proposal","gift"];
